







import {
	defineComponent,
} from '@vue/composition-api';
import RefreshApp from '@front-app/components/RefreshApp.vue';

export default defineComponent({
	components: { RefreshApp },
	setup() {
		return {};
	},
});
